import React from 'react';
function Icon() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path d="M180-120q-24 0-42-18t-18-42v-523q0-15 3-25.5t11-19.5l56-76q8-9 18.5-12.5t24.886-3.5h493.228Q741-840 751-836.5t18 12.5l57 76q8 9 11 19.5t3 25.5v523q0 24-18 42t-42 18H180zm17-614h565l-36.409-46H233l-36 46zm-17 60v494h600v-494H180zm270 404h60v-201l86 86 40-40-156-156-156 156 40 40 86-86v201zm-270 90h600-600z"></path>
    </svg>;
}
export default Icon;